var modMySubscription = function(){
    var scope = ".js-mod-my-subscription";
    ui.ready(
        scope,
        function($mod){
            $mod.find(scope+"__cancel-subscription").click(function(ev){
                ev.preventDefault();
                var $me = $(ev.currentTarget);
                new swal({
                    title: $me.data("cancelConfirmTitle"),
                    text: $me.data("cancelConfirmText"),
                    type: "confirm",
                    showCancelButton: true,
                    confirmButtonColor: "#fc4b6c",
                    confirmButtonText: $me.data("cancelConfirmButton"),
                    cancelButtonText: $me.data("cancelConfirmCancel"),
                    closeOnConfirm: true,
                    closeOnCancel: true
                }).then(
                    function(isConfirm){
                        if(isConfirm.isConfirmed){
                            gvf.endpoint(
                                "web\\subscriptionsController::cancelSubscription",
                                [$mod.data("id")],
                                function(response){
                                    if(response.url){
                                        window.location = response.url;
                                    }else{
                                        utils.alertEndpointResponse(response);
                                    }
                                }
                            );
                        }
                    }
                );
            });

            $mod.find(scope+"__pause-subscription").click(function(ev){
                ev.preventDefault();
                new swal({
                    title: "Pausar subscripción",
                    text: "Se procederá a pausar la suscripción, ¿Desea continuar?",
                    type: "confirm",
                    showCancelButton: true,
                    confirmButtonColor: "#fc4b6c",
                    confirmButtonText: "Aceptar",
                    cancelButtonText: "Mantener suscripción",
                    closeOnConfirm: true,
                    closeOnCancel: true
                }).then(
                    function(isConfirm){
                        if(isConfirm.isConfirmed){
                            gvf.endpoint(
                                "web\\subscriptionsController::pauseSubscription",
                                [$mod.data("id")],
                                function(response){
                                    if(response.url){
                                        window.location = response.url;
                                    }else{
                                        utils.alertEndpointResponse(response);
                                    }
                                }
                            );
                        }
                    }
                );
            });

            $mod.find(scope+"__active-subscription").click(function(ev){
                ev.preventDefault();
                gvf.endpoint(
                    "web\\subscriptionsController::activeSubscription",
                    [$mod.data("id")],
                    function(response){
                        if(response.url){
                            window.location = response.url;
                        }else{
                            utils.alertEndpointResponse(response);
                        }
                    }
                );
            });

            $mod.find(scope+"__modify-subscription").click(function(ev){
                ev.preventDefault();
                gvf.endpoint(
                    "web\\subscriptionsController::modifySubscription",
                    [$mod.data("id")],
                    function(response){
                        if(response.url){
                            window.location = response.url;
                        }else{
                            utils.alertEndpointResponse(response);
                        }
                    }
                );
            });

            $mod.find(scope+"__edit-comment").click(function(ev){
                ev.preventDefault();
                var comments = $mod.find(".js-form-field[data-name='comments'] textarea").val();
                gvf.endpoint(
                    "web\\subscriptionsController::modifyOrderNotes",
                    [$mod.data("id"),comments],
                    function(response){
                        utils.alertEndpointResponse(response);
                    }
                );
            });

        }
    );
}();